import styled from '@emotion/styled';
import { Paper } from '@mui/material';

const InnerTabsWrapper = styled(Paper)({
  marginRight: 12,
  flex: 1,
});

export default InnerTabsWrapper;
